'use client'

import { theme } from '@qr-front/ui'
import { cn, getVersionForClone } from '@qr-front/ui/utils'
import { plainTextAtom } from 'features/generator/contentFormSections/PlainTextForm'
import { QrScreen, TQrScreenProps } from 'features/generator/QrScreen/QrScreen'
import { useAtomValue } from 'jotai'
import { useTranslations } from 'next-intl'

import { slabFont } from './SlabFont'

const Content = ({ demoMode, previewMode }: TQrScreenProps) => {
	const t = useTranslations()

	const plainText = useAtomValue(plainTextAtom)
	const formatted = plainText.replace(/^(\d+)\.\s/gm, '$1.\u00A0')

	return (
		<div
			className={cn(
				'flex min-h-full items-start justify-center bg-plain-text-bg px-5 py-14',
				slabFont.variable,
				'rounded-6',
			)}
		>
			<div
				className={cn(
					'relative w-full max-w-[310px] bg-white px-4 py-8 shadow-generator',
					demoMode && 'pointer-events-none',
					getVersionForClone({
						base: 'rounded-none',
						clone1: 'rounded-8',
					}),
				)}
			>
				<p
					className={cn(
						'font-slab text-black',
						previewMode ? 'type-10' : 'text-body-medium',
					)}
				>
					{plainText ? (
						<span className="whitespace-pre-wrap break-words">{formatted}</span>
					) : (
						<>{t('generator__plain_text__preview__default_placeholder')}</>
					)}
				</p>
			</div>
		</div>
	)
}

export const PlainTextScreen = (props: TQrScreenProps) => (
	<QrScreen
		{...props}
		primaryColor={theme.colors['plain-text-bg']}
		content={<Content {...props} />}
	/>
)
